const inputErrorLabelNew = {
  label: 'The message field cannot be empty'
};

export default inputErrorLabelNew;
